import _extends from '@babel/runtime/helpers/extends';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { T as Text } from '../Text/Text-C6JmRCZS.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-30078624__sc-g0mwes-0"
})(["line-height:1;background:", ";padding:", ";color:", ";position:relative;display:inline-block;top:-0.5em;", ""], ({
  theme
}) => theme.divider.bg, ({
  theme
}) => theme.divider.textPadding, ({
  theme
}) => theme.divider.textColor, isMobile(css(["padding:", ";"], ({
  theme
}) => theme.divider.mobile.textPadding)));
const Divider = /*#__PURE__*/styled(class DividerComponent extends PureComponent {
  render() {
    const {
      text,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
      role: "separator"
    }), text && /*#__PURE__*/React__default.createElement(StyledText, {
      type: "span"
    }, "\xA0", text, "\xA0"));
  }
}).withConfig({
  componentId: "sc-storm-ui-30078624__sc-g0mwes-1"
})(["text-align:center;border-bottom-width:1px;border-bottom-width:thin;border-bottom-style:solid;border-bottom-color:", ";margin:", ";line-height:0;height:0px;", ""], ({
  theme
}) => theme.divider.color, ({
  theme
}) => theme.divider.margin, isMobile(css(["margin:", ";"], ({
  theme
}) => theme.divider.mobile.margin)));
Divider.propTypes = {
  /**
   * Add text to create a text divider
   */
  text: PT.string
};
Divider.defaultProps = {
  text: undefined
};
Divider.displayName = 'Divider';

export { Divider as D };
//# sourceMappingURL=Divider-Hk1RpjMq.js.map
